import { CircleAlert } from 'lucide-react';
import JobMakeChangesButton from '../JobMakeChangesButton';
import useJobChangesRequested from './useJobChangesRequested';

const JobChangesRequested: React.FunctionComponent = function () {
  const { show, request } = useJobChangesRequested();
  if (!show) return null;
  return (
    <div className="flex flex-col md:flex-row gap-y-3  p-3 md:p-4 bg-orange-100 border-2 border-orange-200 rounded-xl md:-mt-6 md:mb-6">
      <div className="flex flex-row gap-x-2">
        <CircleAlert className="text-orange-200 min-w-6" size={24} />
        <div className="flex flex-col gap-y-1">
          <h1 className="text-14-22-em mt-px md:mt-0 md:text-16-24-em">
            Change Request Received
          </h1>
          <h2 className="text-12-18 md:text-14-22">
            You have received a change request for this job
            {request ? (
              <>
                :{' '}
                <span className="text-12-18-em md:text-14-22-em">
                  {request}
                </span>
              </>
            ) : (
              ''
            )}
            .
          </h2>
        </div>
      </div>
      <div className="my-auto md:ml-auto">
        <JobMakeChangesButton />
      </div>
    </div>
  );
};

export default JobChangesRequested;
